import { IUpdateUserService } from "@modules/user/models/IUpdateUserService";
import { IUpdateUserDTO } from "@modules/user/dtos/IUpdateUserDTO";
import { safeExecute } from "@utils/safeExecute";

export function updateUser(service: IUpdateUserService, data: IUpdateUserDTO) {
  return safeExecute(
    () => service.execute(data),
    "Ocorreu um erro ao atualizar usuário"
  );
}
